module.exports = __webpack_public_path__ + "img/icon-white-26.9e4c3e20.svg";